import { getTipLinkUrl } from "./utils.js";
import { v4 as uuid } from "uuid";
export var CallbackType;
(function (CallbackType) {
    CallbackType[CallbackType["DEFAULT"] = 0] = "DEFAULT";
    CallbackType[CallbackType["POST"] = 1] = "POST";
})(CallbackType || (CallbackType = {}));
export class WindowCommunicator {
    constructor(buildEnv, windowOpenFailHandler) {
        this.post = (window, data, publicKeyOverride) => {
            window.postMessage({
                ...data,
                publicKey: publicKeyOverride || this.publicKey,
            }, this.baseUrl);
        };
        this.singlePostToWindow = (window, data) => {
            this.post(window, data);
        };
        this.sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
        this.baseUrl = getTipLinkUrl(buildEnv);
        this.windowOpenFailHandler = windowOpenFailHandler;
    }
    updatePublicKey(publicKey) {
        this.publicKey = publicKey;
    }
    setupWindowWithMessages(otherWindow, windowCallbacks, windowName, endSignals, requestId) {
        const post = this.post.bind(this, otherWindow);
        const endSignalsSet = new Set(endSignals);
        const listener = async (event) => {
            if (event.origin !== this.baseUrl) {
                // console.log("received unoriginal event", event);
                return;
            }
            if (event.data.windowName !== windowName) {
                // console.log("received event for different window", event);
                return;
            }
            if (requestId && event.data.requestId !== requestId) {
                // console.log("received event for different requestId", event);
                return;
            }
            // console.log("received message", event.data);
            if (!event.data?.type) {
                // console.log("missing type in", event.data);
                return;
            }
            const windowCallback = windowCallbacks[event.data.type];
            if (!windowCallback) {
                // console.log("NO WINDOW CALLBACK", event.data.type);
                return;
            }
            const { type, cb: callback } = windowCallback;
            // console.log("type", type, "callback", callback);
            if (endSignalsSet.has(event.data.type)) {
                window.removeEventListener("message", listener);
            }
            if (callback) {
                switch (type) {
                    case CallbackType.DEFAULT:
                        void callback(event.data);
                        break;
                    case CallbackType.POST:
                        post(await callback(event.data));
                        break;
                }
            }
        };
        window.addEventListener("message", listener);
        return {
            post,
            close: () => {
                window.removeEventListener("message", listener);
            },
        };
    }
    setupHandshakeWithIframe(iFrame, windowCallbacks, endSignals, requestId) {
        const windowName = iFrame.name;
        const iframeWindow = iFrame.contentWindow;
        if (!iframeWindow) {
            throw Error("no contentWindow in iFrame provided: " + windowName);
        }
        return this.setupWindowWithMessages(iframeWindow, windowCallbacks, windowName, endSignals, requestId);
    }
    openPopup(path) {
        const url = new URL(path, this.baseUrl);
        const windowName = uuid();
        const width = 400;
        const height = 600;
        // Calculate the position
        const top = window.top || window;
        const y = top.outerHeight / 2 + top.screenY - height / 2;
        const x = top.outerWidth / 2 + top.screenX - width / 2;
        const popup = window.open(url, windowName, `width=${width}, height=${height}, top=${y}, left=${x}`);
        return {
            popup,
            url,
            windowName,
            dimensions: {
                x,
                y,
                width,
                height,
            },
        };
    }
    async setupHandshakeWithWindowParams(windowOpenParams, windowCallbacks, endSignals) {
        const { popup, url, windowName, dimensions: { x, y, width, height }, } = windowOpenParams;
        return this.setupWindowWithMessages(popup, windowCallbacks, windowName, endSignals);
    }
}
//# sourceMappingURL=window.js.map